/*
 * @Author: bpang bpang@vocust.com
 * @Date: 2024-08-14 10:53:00
 * @LastEditors: bpang bpang@vocust.com
 * @LastEditTime: 2024-08-16 14:41:31
 * @FilePath: /report/packages/report/src/hotelcem/apis/notice/notice.js
 * @Description:
 *
 */
import { fetch } from '@/hotelcem/apis/request'
const baseURL = `${process.env.VUE_APP_APIBASEURL}/api/v1`

export default {
  //未读&未提醒消息数量查询

  getUnreadCount(params = {}) {
    return fetch({
      baseURL,
      url: '/bulletin-front/system-notify/unread-unnotify/count',
      method: 'POST',
      data: params,
    })
  },
  //通知列表
  getNoticeList(params) {
    return fetch({
      baseURL,
      url: '/bulletin-front/system-notify/list',
      method: 'POST',
      data: params,
    })
  },
  //通知记录修改
  updateMaxNotify(params) {
    return fetch({
      baseURL,
      url: '/bulletin-front/system-notify/record/update',
      method: 'POST',
      data: params,
    })
  },

  //通知记录修改
  noticeRead(params) {
    return fetch({
      baseURL,
      url: '/bulletin-front/system-notify/read',
      method: 'POST',
      data: params,
    })
  },
}
